<section class="fullHeight flex sec bg">
    <div class="pad  fullWidth">
        <div class="flex">
            <div style="flex: 1;gap: 20px;flex-direction: column; align-items: start;" class="flex">
                <p class="fs">Get Travel Insurance</p>
                <p  class="fs">in minutes...</p>
                <h2 class="fs" style="color: var(--primary-color);">it's that Simple</h2>
            </div>
            <div style="flex: 1;" class="flex">

                <div style="flex-direction: column;" class="formCar flex">
                    <h4>Welcome🖐</h4>
                    <br>
                    <div>
                        <p>Sign up to get started</p>
                    </div>
                    <br>
                    <form [formGroup]="signInForm" class="flex" style="flex-direction: column;height:100%;">
                        <div>
                            <mat-form-field >
                                <mat-label> Email</mat-label>
                                <input type="email" formControlName="email" matInput>
                            </mat-form-field>
                            <div style="position: relative;">

                                <mat-form-field>
                                    <mat-label> password</mat-label>
                                    <input [type]="hide ? 'password' : 'text'" formControlName="password" matInput>
                                </mat-form-field>
                                <mat-icon style="    margin-left: -35px;" class="eye" (click)="eye()">
                                    {{hide ? 'visibility_off' : 'visibility'}}
                                </mat-icon>

                            </div>
                            <button type="button" style="width: 100%;" (click)="signIn()" color="accent" mat-flat-button>Sign In</button>
                        </div>
                    </form>
                    <br><br>
                    <div class="flex">
                        <p>Don't have an Account? &nbsp;</p>
                        <a routerLink="/signup" style="color: var(--primary-color);">Sign Up</a>
                    </div>
                    <br>
                    <div>
                        <a routerLink="/forgetPassword">
                        <p>Forget Password?</p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>